var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import 'formdata-polyfill';
import 'whatwg-fetch';
export var pardotFormHandler = function (url, formElement, onSubmitted) {
    var e_1, _a;
    var formdata = new FormData(formElement);
    var data = {};
    try {
        // @ts-ignore
        // eslint-disable-next-line no-restricted-syntax
        for (var _b = __values(formdata.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var pair = _c.value;
            var _d = __read(pair, 2), key = _d[0], value = _d[1];
            data[key] = value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    pardotPostData(url, data, onSubmitted);
};
export var pardotPostData = function (url, data, onSubmitted) {
    var urlParams = new URLSearchParams();
    Object.keys(data).forEach(function test(key) {
        urlParams.append(key, data[key]);
    });
    fetch(url, {
        method: 'post',
        mode: 'no-cors',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body: urlParams,
    })
        .then(function () {
        if (onSubmitted) {
            onSubmitted(data);
        }
    })
        .catch(function () {
        // do nothing for now DataDog later
    });
};
